import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import { getApiBaseUrl } from '../../utils/utils'; 
export default function AttendanceSettingEdit() {

    const API_URL = process.env.REACT_APP_API_URL;
    const [msg, setMsg] = useState('')


    const [errormsg, setErrorMsg] = useState('');


    const navigate = useNavigate();

    const location = useLocation();
  const { driverId, partnerId } = location.state || {};

    const [selectedPartner, setSelectedPartner] = useState(partnerId);

 



    const [searchQuery, setSearchQuery] = useState("");

    const [partners, setPartners] = useState([]);
    useEffect(() => {
        const fetchPartners = async () => {

            const baseApiUrl = getApiBaseUrl();
            try {
                const response = await axios.get(`${baseApiUrl}/v1.0/partner/retrieve_list?page=0`);
                setPartners(
                    (response.data.data || [])
                );

            } catch (err) {
                setErrorMsg(err.message || 'Error fetching data');
            } finally {
                // setLoading(false);
            }
        };

        fetchPartners();
    }, []);


    const handleSelectChange = (e) => {
        const partnerId = e.target.value;

        if (partnerId === '0') {
            setSelectedPartner('0');

            return;
        }

        const partner = partners.find((p) => String(p.pid) === partnerId);
        setSelectedPartner(partner.pid);
        getHomebaseList(partner.pid)

    };


    const [settings, setSettings] = useState({
        require_attendance: "0",
        login_logout_required: "0",
        geo_restriction_enabled: "0",
        logout_anywhere_allowed: "0",
        drivers: [],
    });

    useEffect(() => {
        // Fetch drivers from the API on component mount
        fetchDrivers();
        getHomebaseList(partnerId);

    }, [partnerId]);

    console.log(settings)



    const [homebases, sethomebases] = useState([])
    const getHomebaseList = async (selectedPartner) => {
        const API_PATH = `${API_URL}shypvdriverapp/partner-warehouse?partnerId=${selectedPartner}`;

        try {
            const res = await axios.get(API_PATH);
            console.log(res.data);
            if (res.data.success == true) {
                sethomebases(res.data.data);
            } else {
                console.log('false')
            }

        } catch (err) {
            console.log(err);
        }
    };






    const [scaninfo, setScanInfo] = useState({
        drivers: [],
        locations: [],
    });


    const [driverOptions, setDriverOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);

    console.log('homebases', homebases)
    console.log('drivers', scaninfo)
    const [drivers, setDrivers] = useState()
    const fetchDrivers = async () => {
        try {
            // Replace this API endpoint with the actual one that fetches drivers based on the emirate
            const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

            if (response.data.success) {
                const driversData = response.data.data;  // The array of driver objects

                // Map the response to extract driverId and name
                const driversList = driversData.map(driver => ({
                    driver_id: driver.driverId,
                    driver_name: driver.name
                }));

                // Set the drivers state
                setDrivers(driversList);
            } else {
                console.error('Error fetching drivers for emirate:');
            }
        } catch (error) {
            console.error('Error fetching drivers:', error);
        }
    };

    const filteredDrivers = Array.isArray(drivers)
        ? drivers.filter(driver =>
            driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        : [];

        



    const buttonsyle = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginRight: '10px',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%'
    }




    const saveConfig = async () => {
        setErrorMsg('')
        const API_PATH = `${API_URL}shypvdriverapp/attendance-config/new`;

        try {
            const payload = {

                requireAttendance: settings.require_attendance == 1 ? true : false,
                allowLogoutAnywhere: settings.logout_anywhere_allowed == 1 ? true : false,
                enableGeoRestriction: settings.geo_restriction_enabled == 1 ? true : false,
                driverIds: settings.drivers.map(Number), // convert all IDs to numbers
                partnerId: Number(selectedPartner), // assuming user id is partnerId
                checkinWarehouseIds: settings.locations.map(Number),
                checkoutWarehouseIds: settings.locations.map(Number), // or use a different field if you have
            };

            const res = await axios.post(API_PATH, payload, {
                headers: { 'Content-Type': 'application/json' },
            });

            if (res.data.success) {
                console.log('Attendance settings saved successfully:', res.data);
                navigate('/orders/attendance-config');
            } else {
                console.log('Failed to save settings:', res.data.message);
                setErrorMsg('Failed to save settings:', res.data.message)
            }
        } catch (err) {
            console.error('Error saving attendance settings:', err);
        }
    };




    useEffect(() => {
        // Construct API URL
let apiUrl;
        if (driverId && driverId >0 ){
apiUrl = `${API_URL}shypvdriverapp/attendance-config/all?driverId=${driverId}&page=0&size=10`;

        }else{
 apiUrl = `${API_URL}shypvdriverapp/attendance-config/all?partnerId=${partnerId}&page=0&size=20`;

        }
       
        // Fetch the data from the API
   fetch(apiUrl)
  .then(res => res.json())
  .then(result => {
    if (result.success && result.data.content.length > 0) {
      const content = result.data.content;
      const first = content[0];

      // ✅ Combine drivers
      const driverOptions = content.map(item => ({
        value: item.driver.id,
        label: item.driver.name
      }));
      const uniqueDrivers = Array.from(
        new Map(driverOptions.map(d => [d.value, d])).values()
      );
      const driverIds = uniqueDrivers.map(d => d.value);

      // ✅ Combine locations (checkin + checkout)
      const allLocations = content.flatMap(item => [
        ...(item.checkinWarehouses || []),
        ...(item.checkoutWarehouses || [])
      ]);

      const locationOptions = Array.from(
        new Map(
          allLocations.map(loc => [
            loc.id,
            { value: loc.id, label: loc.name }
          ])
        ).values()
      );
      const locationIds = locationOptions.map(l => l.value);

      // ✅ Set settings
      setSettings({
        require_attendance: first.requireAttendance ? "1" : "0",
        login_logout_required: first.allowLogoutAnywhere ? "1" : "0",
        geo_restriction_enabled: first.enableGeoRestriction ? "1" : "0",
        logout_anywhere_allowed: first.allowLogoutAnywhere ? "1": "0",
        drivers: driverIds,
        locations: locationIds
      });

      // ✅ Set dropdown options
      setDriverOptions(uniqueDrivers);
      setLocationOptions(locationOptions);

      // ✅ Update scan info if needed
      setScanInfo({ ...scaninfo, drivers: driverIds });
    } else {
      setErrorMsg("No data available");
    }
  })
  .catch(error => {
    console.error("Error fetching data:", error);
    setErrorMsg("An error occurred while fetching the data.");
  });

    }, [partnerId]);



    useEffect(() => {
  if (drivers && settings?.drivers) {
    // Build driver options from all drivers API
    const driverOptions = drivers.map(d => ({
      value: d.driver_id,
      label: d.driver_name
    }));

    setDriverOptions(driverOptions);
  }
}, [drivers, settings]);



useEffect(() => {
  if (homebases.length > 0 && settings?.locations) {
    // Build dropdown options from all available homebases
    const allLocationOptions = homebases.map(loc => ({
      value: loc.id,
      label: loc.name
    }));

    setLocationOptions(allLocationOptions);
  }
}, [homebases, settings]);




    console.log('settings', settings)

    return (
        <div>
            {settings && (
                <div className="form-container">
                    <div className="row">
                        <div className="col-md-6">
                            <h5 style={{ float: 'left' }}>Attendance Settings</h5>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="partner" className="m-form">Partner*</label>
                                <select onChange={handleSelectChange} value={selectedPartner} style={{ marginRight: '10px' }}>
                                    <option value="" disabled>-- Select a partner --</option>
                                    <option value="0">All</option>
                                    {partners && [...partners].sort((a, b) => a.pname.localeCompare(b.pname)).map((partner) => (
                                        <option key={partner.pid} value={partner.pid}>
                                            {partner.pname}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="requireAttendance" className="m-form">Required Attendance</label>
                                <select
                                    value={settings.require_attendance}
                                    onChange={e => setSettings({ ...settings, require_attendance: e.target.value })}
                                    style={{ marginRight: '10px' }}
                                >
                                    <option value="0">NO</option>
                                    <option value="1">YES</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="loginLogoutRequired" className="m-form">Required Logout attendance?</label>
                                <select
                                    value={settings.login_logout_required}
                                    onChange={e => setSettings({ ...settings, login_logout_required: e.target.value })}
                                    disabled={!settings.require_attendance}
                                    style={{ marginRight: '10px' }}
                                >
                                    <option value="0">NO</option>
                                    <option value="1">YES</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="logoutAnywhereAllowed" className="m-form">Allow Logout anywhere?</label>
                                <select
                                    value={settings.logout_anywhere_allowed}
                                    onChange={e => setSettings({ ...settings, logout_anywhere_allowed: e.target.value })}
                                    disabled={!settings.require_attendance || !settings.login_logout_required}
                                    style={{ marginRight: '10px' }}
                                >
                                    <option value="0">NO</option>
                                    <option value="1">YES</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="geoRestrictionEnabled" className="m-form">Enable Geo Restrictions?</label>
                                <select
                                    id="geoRestrictionEnabled"
                                    value={settings.geo_restriction_enabled} // default to "0" if undefined
                                    onChange={(e) =>
                                        setSettings({
                                            ...settings,
                                            geo_restriction_enabled: e.target.value,
                                        })
                                    }
                                    disabled={settings.require_attendance !== "1"} // ensure type match with "1" or "0"
                                    style={{ marginRight: "10px" }}
                                >
                                    <option value="0">NO</option>
                                    <option value="1">YES</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="drivers" className="m-form">Select Drivers</label>
                                <Select
                                    isMulti
                                    options={driverOptions}
                                    value={driverOptions.filter(option =>
                                        scaninfo?.drivers?.includes(option.value)
                                    )}
                                    onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions
                                            ? selectedOptions.map(option => option.value)
                                            : [];
                                        setScanInfo({ ...scaninfo, drivers: selectedValues });
                                        setSettings({ ...settings, drivers: selectedValues });
                                    }}
                                    placeholder="Select drivers"
                                    isSearchable
                                    noOptionsMessage={() => "No drivers found"}
                                />
                            </div>
                        </div>
                    </div>

                    {settings.geo_restriction_enabled === "1" && (
                        <div className="form-group">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="locations" className="m-form">Select Locations</label>
                                        <Select
                                            isMulti
                                            options={locationOptions}
                                            value={locationOptions.filter(option =>
                                                settings?.locations?.includes(option.value)
                                            )}
                                            onChange={(selectedOptions) => {
                                                const selectedValues = selectedOptions
                                                    ? selectedOptions.map(option => option.value)
                                                    : [];
                                                setSettings({ ...settings, locations: selectedValues });
                                            }}
                                            placeholder="Select locations"
                                            isSearchable
                                            noOptionsMessage={() => "No locations found"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <a onClick={saveConfig} style={buttonsyle}  type="button" className="btn-demo add">
                        Submit
                    </a>
                    <p>{errormsg}</p>
                </div>

            )
            }
        </div>
    )
}
